"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ProgressBar;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ProgressBarModule = _interopRequireDefault(require("./ProgressBar.module.scss"));

var _pad = _interopRequireDefault(require("../pad"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var FILLER_MAX_WIDTH_PX = 542;
var SECONDARY_FILLER_MAX_WIDTH_PX = 436;

function ProgressBar(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? "default" : _ref$type,
      children = _ref.children,
      filledPerc = _ref.filledPerc,
      isBlinking = _ref.isBlinking,
      _ref$showValue = _ref.showValue,
      showValue = _ref$showValue === void 0 ? false : _ref$showValue,
      _ref$padValue = _ref.padValue,
      padValue = _ref$padValue === void 0 ? false : _ref$padValue,
      _ref$radialFillColor = _ref.radialFillColor,
      radialFillColor = _ref$radialFillColor === void 0 ? "#BFE3FF" : _ref$radialFillColor,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style;
  var renderDefault = (0, _react.useCallback)(function () {
    var fillerMaxWidth = type === "secondary" ? SECONDARY_FILLER_MAX_WIDTH_PX : FILLER_MAX_WIDTH_PX;
    var fillerWidthPx = Math.ceil(fillerMaxWidth / 100 * filledPerc);
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(_ProgressBarModule.default.progressBar, type !== "default" && _ProgressBarModule.default[type], className),
      style: style
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(_ProgressBarModule.default.filler, isBlinking && _ProgressBarModule.default.isBlinking),
      style: {
        width: "".concat(fillerWidthPx, "px")
      }
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: _ProgressBarModule.default.text
    }, children && children, children && showValue && " ", showValue && "".concat(padValue ? (0, _pad.default)(filledPerc.toString(), 3) : filledPerc.toString(), "%")));
  }, [type, filledPerc, className, style, isBlinking, children, showValue, padValue]);
  var renderDonut = (0, _react.useCallback)(function () {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(_ProgressBarModule.default.donut, className),
      style: style
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _ProgressBarModule.default.donutChart
    }, /*#__PURE__*/_react.default.createElement("svg", {
      viewBox: "0 0 32 32"
    }, /*#__PURE__*/_react.default.createElement("circle", {
      r: "16",
      cx: "16",
      cy: "16",
      style: {
        stroke: radialFillColor,
        strokeDasharray: "".concat(filledPerc, " 100")
      }
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: _ProgressBarModule.default.donutCenter
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _ProgressBarModule.default.text
    }, children && {
      children: children
    }, showValue && filledPerc.toString()))));
  }, [className, style, radialFillColor, filledPerc, children, showValue]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, type !== "comboRadial" && renderDefault(), type === "comboRadial" && renderDonut());
}